import { useMemo } from 'react'
import { usePeriodReportSnapshots } from './usePeriodReportSnapshots'
import { usePeriodReportSnapshotData } from './usePeriodReportSnapshotData'
import { getReportSnapshotIds } from '../../utils/getReportSnapshotIds'

export const usePeriodReportData = (reportId: string | null) => {
  const { data: periodReports, isLoading: isPeriodReportsLoading } =
    usePeriodReportSnapshots()

  const selectedReport = useMemo(() => {
    if (!reportId || !periodReports) return null
    return periodReports.find((report) => report.id === reportId) || null
  }, [reportId, periodReports])

  const { previousSnapshotId, currentSnapshotId } = useMemo(
    () => getReportSnapshotIds(selectedReport),
    [selectedReport]
  )
  const { previousSnapshot, currentSnapshot } = usePeriodReportSnapshotData(
    previousSnapshotId,
    currentSnapshotId
  )

  const isSnapshotPending =
    (!!previousSnapshotId && previousSnapshot.isPending) ||
    (!!currentSnapshotId && currentSnapshot.isPending)

  return {
    previousSnapshot: previousSnapshot?.data,
    currentSnapshot: currentSnapshot?.data,
    currentSnapshotId,
    isPeriodReportsLoading,
    selectedReport,
    isLoading:
      isPeriodReportsLoading ||
      isSnapshotPending ||
      previousSnapshot.isFetching ||
      currentSnapshot.isFetching,
  }
}
